import React, { useState } from 'react'
import { Modal, Tooltip } from 'antd'

export function isAbsoluteUrl(str, { allowedProtocols = ['http:', 'https:'] } = {}) {
    if (!str || typeof str !== 'string') return false;
    try {
        const u = new URL(str)
        return allowedProtocols.length === 0 || allowedProtocols.includes(u.protocol);
    } catch (e) {
        return false
    }
}

function ThreadColorImage(prop) {
    const { ImageUrl } = prop
    const [showPreviewThreadColorImg, setShowPreviewThreadColorImg] = useState(false)

    const _handleToggleModalPreviewThreadColorImg = () => {
        setShowPreviewThreadColorImg(!showPreviewThreadColorImg)
    }

    return (!!isAbsoluteUrl(ImageUrl) ?
        <React.Fragment>
            <Tooltip title='Ảnh mô tả màu chỉ'>
                <a
                    href={ImageUrl} target='_blank'
                    onClick={(e) => {
                        e.preventDefault()
                        _handleToggleModalPreviewThreadColorImg()
                    }}
                >
                    <i className="fa fa-image" /> Ảnh mô tả
                </a>
            </Tooltip>
            <Modal
                title='Ảnh mô tả màu chỉ'
                visible={showPreviewThreadColorImg}
                footer={false}
                onCancel={() => _handleToggleModalPreviewThreadColorImg()}
            >
                <img
                    alt="Ảnh mô tả màu chỉ"
                    style={{ width: '100%' }}
                    src={ImageUrl}
                />
            </Modal>
        </React.Fragment> :
        ImageUrl
    )
}

export default ThreadColorImage